import {CalendarX} from "lucide-react";

import {Button} from "@/components/ui/button";
import {Card, CardContent} from "@/components/ui/card";

export function EmptyShift() {
  return (
    <Card className="flex h-full min-h-0 flex-1 flex-col border-2 border-dashed shadow-none">
      <CardContent className="flex flex-1 flex-col items-center justify-center py-16 text-center">
        <div className="rounded-full bg-muted p-6 mb-4">
          <CalendarX className="h-12 w-12 text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold mb-2">No Upcoming Shifts</h3>
        <p className="text-muted-foreground mb-6 max-w-sm">
          You don't have any shifts scheduled at the moment. Check back later or contact your
          supervisor.
        </p>
        <div>
          <Button variant="link">View shift history</Button>
        </div>
      </CardContent>
    </Card>
  );
}
